import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminHeaderComponent } from './admin-header/admin-header.component';
import { LeftNavigationComponent } from './left-navigation/left-navigation.component';

@Component({
  selector: 'app-admin-layout',
  imports: [RouterOutlet, LeftNavigationComponent, AdminHeaderComponent],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent {}
